import { useState } from 'react';

import { CustomAlert, CustomButton } from '../../../shared/uiComponents';
import Content from './content';

const DiscretionaryHoursAllocation = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<CustomButton
				title="Allocate Non-Billable Hours"
				onClick={() => setOpen(true)}
				buttonType="outlined"
				className="marginBottom16"
			/>
			<CustomAlert
				open={open}
				onClose={() => setOpen(false)}
				title="Allocate Non-Billable Hours"
				Content={Content}
				maxWidth="sm"
			/>
		</>
	);
};

export default DiscretionaryHoursAllocation;
